import { render, staticRenderFns } from "./HowToUploadWallpaper.vue?vue&type=template&id=4d3e28fa&scoped=true&"
import script from "./HowToUploadWallpaper.vue?vue&type=script&lang=js&"
export * from "./HowToUploadWallpaper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3e28fa",
  null
  
)

export default component.exports